module.exports = __webpack_public_path__ + "assets/img/652300.bee0f0f5.png";